import {
    HIDE_MESSAGE,
    INIT_URL,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SIGNOUT_USER,
    SIGNIN_USER_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    SIGNUP_USER_SUCCESS
} from 'constants/ActionTypes';

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    initURL: '',
    authUser: localStorage.getItem('authToken'),
    tokenExpireTime: localStorage.getItem('tokenExpireTime'),
    loggedIn: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SIGNUP_USER_SUCCESS: {
            return {
                ...state,
                loader: false,
                authUser: action.payload
            };
        }
        case SIGNIN_USER_SUCCESS: {
            return {
                ...state,
                loader: false,
                loggedIn: true,
                tokenExpireTime: action.payload.tokenExpireTime ? action.payload.tokenExpireTime : state.tokenExpireTime,
                authUser: action.payload.token
            };
        }
        case INIT_URL: {
            return {
                ...state,
                initURL: action.payload
            };
        }
        case SIGNOUT_USER_SUCCESS: {
            return {
                ...state,
                authUser: null,
                initURL: '/',
                loader: false
            };
        }

        case SIGNOUT_USER:
            return {
                ...state,
                authUser: null,
                tokenExpireTime: null,
                initURL: '/',
                loggedIn: false,
                loader: false
            };

        case SHOW_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case HIDE_MESSAGE: {
            return {
                ...state,
                alertMessage: '',
                showMessage: false,
                loader: false
            };
        }

        case ON_SHOW_LOADER: {
            return {
                ...state,
                loader: true
            };
        }
        case ON_HIDE_LOADER: {
            return {
                ...state,
                loader: false
            };
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/Auth.js